export default __webpack_public_path__ + "static/media/testfab.8a338441.jpg";